import React from "react";

const GeneralDentistry = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-[#051518] py-16 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <h1 className="text-5xl font-bold text-center text-green-600 dark:text-[#56b255] mb-10 pt-20">
          General Dentistry
        </h1>

        {/* Procedure Section */}
        <div className="grid md:grid-cols-2 gap-12">
          {/* Left Section: Procedures */}
          <div className="bg-white dark:bg-[#0B252B] shadow-lg dark:shadow-none rounded-lg p-8 hover:shadow-2xl transition-all duration-300 ease-in-out border border-transparent dark:border-white/5">
            <h2 className="text-4xl font-semibold text-gray-800 dark:text-white mb-6">
              Our Procedures
            </h2>
            <p className="text-lg text-gray-600 dark:text-slate-300 mb-6">
              We offer a wide variety of general dentistry services to keep your
              smile healthy and bright. Our goal is to provide high-quality care
              that meets your individual needs.
            </p>

            <ul className="space-y-4 text-lg text-gray-600 dark:text-slate-300">
              <li className="flex items-center">
                <span className="w-8 h-8 bg-blue-500 text-white rounded-full flex justify-center items-center mr-4">
                  🦷
                </span>
                Routine Checkups & Cleanings
              </li>
              <li className="flex items-center">
                <span className="w-8 h-8 bg-green-500 text-white rounded-full flex justify-center items-center mr-4">
                  🛠️
                </span>
                Fillings & Restorations
              </li>
              <li className="flex items-center">
                <span className="w-8 h-8 bg-yellow-500 text-white rounded-full flex justify-center items-center mr-4">
                  🛡️
                </span>
                Preventive Care & Advice
              </li>
              <li className="flex items-center">
                <span className="w-8 h-8 bg-pink-500 text-white rounded-full flex justify-center items-center mr-4">
                  📸
                </span>
                Dental Examinations & X-rays
              </li>
              <li className="flex items-center">
                <span className="w-8 h-8 bg-indigo-500 text-white rounded-full flex justify-center items-center mr-4">
                  ⚒️
                </span>
                Tooth Extractions
              </li>
            </ul>
          </div>

          {/* Right Section: Why Choose Us */}
          <div className="bg-white dark:bg-[#0B252B] shadow-lg dark:shadow-none rounded-lg p-8 hover:shadow-2xl transition-all duration-300 ease-in-out border border-transparent dark:border-white/5">
            <h2 className="text-4xl font-semibold text-gray-800 dark:text-white mb-6">
              Why Choose Us?
            </h2>
            <p className="text-lg text-gray-600 dark:text-slate-300 mb-6">
              At our practice, we prioritize your comfort and care. We use the
              latest dental technology to provide safe and effective treatments,
              ensuring that your dental experience is as painless and
              stress-free as possible.
            </p>
            <p className="text-lg text-gray-600 dark:text-slate-300 mb-6">
              Our team is dedicated to making sure that each visit leaves you
              with a smile on your face. Whether you need a routine checkup or a
              more complex procedure, we are here to support you every step of
              the way.
            </p>
            {/* <button className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition duration-300">
              Book an Appointment
            </button> */}
          </div>
        </div>

        {/* Testimonials Section (Optional) */}
        {/* <div className="mt-16 text-center">
          <h3 className="text-3xl font-semibold text-gray-800 mb-6">
            What Our Patients Say
          </h3>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-6">
            "I had an excellent experience at this dental clinic. The staff was
            friendly, the office was clean, and the procedure was quick and
            painless. Highly recommend!"
          </p>
          <p className="text-lg text-gray-600">- Emily R., Happy Patient</p>
        </div> */}
      </div>
    </div>
  );
};

export default GeneralDentistry;
